// extracted by mini-css-extract-plugin
export default {"wrapper":"fUu4YU","calculationWrapper":"yKND5V"};